import {
  PageWrapper,
  HeroSection,
  HeroOverlay,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  AboutUsSection,
  AboutUsContent,
  AboutUsImageWrapper,
  AboutUsImage,
  AboutUsTextWrapper,
  AboutUsTitle,
  AboutUsText,
} from "./about-us.styles";

import UnderConstructionImg from "../../assets/under-contruction.png";

const AboutUs = () => {
  return (
    <PageWrapper aria-labelledby="about-us-heading">
      {/* Hero with parallax-style background */}
      <HeroSection
        role="banner"
        aria-label="Team Bakery under construction with homemade baked goods theme"
      >
        <HeroOverlay />
        <HeroContent>
          <HeroTitle>Art of Homemade Goods!</HeroTitle>
          <HeroSubtitle>
            Freshly baked treats crafted with care and shared with love.
          </HeroSubtitle>
        </HeroContent>
      </HeroSection>

      {/* About section */}
      <AboutUsSection>
        <AboutUsContent>
          {/* Sticky image column – appears to “stand still” while text scrolls */}
          <AboutUsImageWrapper aria-hidden="true">
            <AboutUsImage
              src="https://www.allrecipes.com/thmb/GPqr9kEn84Kj00QL56aObbv1ci0=/0x512/filters:no_upscale():max_bytes(150000):strip_icc()/260540-Chef-Johns-Sourdough-Bread-DDMFS-004-4x3-6791a75a5d804ec28424d04756054c5b.jpg"
              alt=""
            />
          </AboutUsImageWrapper>

          <AboutUsTextWrapper>
            <AboutUsTitle id="about-us-heading">About TEAM Bakery</AboutUsTitle>
            <AboutUsText>
              Welcome to <strong>TEAM Bakery</strong>, your number one source for
              all things homemade and delicious. We&apos;re dedicated to bringing
              you fresh baked goods made with quality ingredients and a personal
              touch.
            </AboutUsText>
            <AboutUsText>
              Whether you&apos;re craving bread, pastries, or sweet desserts, our
              goal is to create treats that feel like home&mdash;warm, welcoming,
              and unforgettable. Thank you for visiting TEAM Bakery. We can&apos;t
              wait to share our latest creations with you.
            </AboutUsText>
          </AboutUsTextWrapper>
        </AboutUsContent>
      </AboutUsSection>
    </PageWrapper>
  );
};

export default AboutUs;
